import React, {useState} from "react";
import './addBusinessSetions.scss';
import {ReactComponent as BUSINESS_ICON} from "../../../../../assets/icons/business_icon.svg";
import RadioField from "../../../../../components/radio-field/RadioField";
import {Button} from "../../../../../components";

interface Props {
    changeStep: (direction: string) => void;
}

export const AddBusinessStart: React.FC<Props> = ({changeStep}) => {
    const [isAgree, setIsAgree] = useState<boolean>(false)

    const onChange = (event: any) => {
        event.preventDefault();
        setIsAgree(event.target.value)
    }

    const getStarted = () => {
        if (isAgree)
            changeStep('next')
    }

    return (
        <div className={'add-business-section add-business-start'}>
            <BUSINESS_ICON/>
            <h1>Add Business</h1>
            <p>Join us today, and let us help you keep on track with all your investments.</p>
            <div className={'add-business-start_terms'}>
                <RadioField
                    id={'terms'}
                    name={'terms'}
                    text={''}
                    onchange={onChange}
                    value={'true'}
                />
                <span>I agree to the  <span>Terms & Conditions </span> </span>
            </div>

            <Button text={'Get Started'} type={'primary'} onclick={getStarted}/>
        </div>
    );
};